module.exports = __webpack_public_path__ + "img/live_pen.751f7a86.png";